import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-datatables',
	templateUrl:'./DataTablesPluginPage.html',
	styles: [],
	styleUrls:['./DataTablesPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class DataTablesPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_554 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>data-tables</artifactId>
</dependency>
\`\`\``;
	mdContent_555 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:data-tables:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_556 = `\`\`\`json
"datatables.net": "^2.3.8"
"datatables.net-dt": "^2.3.8"
"jszip": "^3.10.1"
"pdfmake": "^0.3.7"
\`\`\``;
	mdContent_557 = `\`\`\`java
DataTable<?> table = new DataTable<>("users");
table.getOptions()
     .setPaging(true)
     .setSearching(true)
     .setOrdering(true)
     .setInfo(true);
\`\`\``;
	mdContent_558 = `\`\`\`java
table.getOptions().getButtons().add(DataTableButtons.Copy);
table.getOptions().getButtons().add(DataTableButtons.Excel);
table.getOptions().getButtons().add(DataTableButtons.Pdf);
table.getOptions().getButtons().add(DataTableButtons.Csv);
\`\`\``;
	mdContent_559 = `\`\`\`java
table.getOptions().setServerSide(true);
table.getOptions().getAjax()
     .setUrl("/api/users")
     .setType("POST");
\`\`\``;
	mdContent_560 = `\`\`\`java
DataTable<?> table = new DataTable<>("myTable");
table.getOptions()
     .setPaging(true)
     .setSearching(true)
     .setOrdering(true);

// Add export buttons
table.getOptions().getButtons()
     .add(DataTableButtons.Excel);
table.getOptions().getButtons()
     .add(DataTableButtons.Pdf);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
